// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-container {
    display: none;
}

.lesson-title{
    column-gap: 20px;
}

.locked-lesson{
    cursor: not-allowed;
}

.locked-lesson .locked-quiz{
    cursor: not-allowed !important;
}

.lesson-wrapper{
    border: 1px solid #cccccc94;
    padding: 20px;
}

.lesson-wrapper li{
    list-style: none;
}

.file-download-btn{
    border: none;
    padding: 3px 15px;
    border-radius: 15px;
    color: #000;
    background-color: rgb(204, 204, 204, 0.3);
}

.file-download-btn:hover{
    color: #000;
}

.download-btn, .file-view-btn{
    background-color: white;
    border: none;
    color: var(--dBlue);
    font-size: 28px;
}

.play-quiz-btn{
    background-color: var(--dBlue);
    color: #fff;
    font-size: 16px;
    border: none;
    border-radius: 20px;
    padding: 5px 20px;
}

#pdf-download{
    display: none;
}

.course-progress-container{
    width: 100%;
    border: 2px solid #264ec8;
    border-radius: 15px;
    padding: 10px 20px;
    margin-bottom: 10px;
}

.course-progress-container p{
    color: var(--dPink);
    margin-bottom: 10px;
}

@media (max-width: 767px) {
    .accordion-container {
        display: block;
    }

    .hide-accordion {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/component/course-page/cp-tab/CourseContent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".accordion-container {\r\n    display: none;\r\n}\r\n\r\n.lesson-title{\r\n    column-gap: 20px;\r\n}\r\n\r\n.locked-lesson{\r\n    cursor: not-allowed;\r\n}\r\n\r\n.locked-lesson .locked-quiz{\r\n    cursor: not-allowed !important;\r\n}\r\n\r\n.lesson-wrapper{\r\n    border: 1px solid #cccccc94;\r\n    padding: 20px;\r\n}\r\n\r\n.lesson-wrapper li{\r\n    list-style: none;\r\n}\r\n\r\n.file-download-btn{\r\n    border: none;\r\n    padding: 3px 15px;\r\n    border-radius: 15px;\r\n    color: #000;\r\n    background-color: rgb(204, 204, 204, 0.3);\r\n}\r\n\r\n.file-download-btn:hover{\r\n    color: #000;\r\n}\r\n\r\n.download-btn, .file-view-btn{\r\n    background-color: white;\r\n    border: none;\r\n    color: var(--dBlue);\r\n    font-size: 28px;\r\n}\r\n\r\n.play-quiz-btn{\r\n    background-color: var(--dBlue);\r\n    color: #fff;\r\n    font-size: 16px;\r\n    border: none;\r\n    border-radius: 20px;\r\n    padding: 5px 20px;\r\n}\r\n\r\n#pdf-download{\r\n    display: none;\r\n}\r\n\r\n.course-progress-container{\r\n    width: 100%;\r\n    border: 2px solid #264ec8;\r\n    border-radius: 15px;\r\n    padding: 10px 20px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.course-progress-container p{\r\n    color: var(--dPink);\r\n    margin-bottom: 10px;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .accordion-container {\r\n        display: block;\r\n    }\r\n\r\n    .hide-accordion {\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
